// Ô CHỌN BẰNG NÚT BẤM (segmented) dùng chung cho Kho video (hộp "Đăng ngay…") và ô cấu hình bước Đăng video của trang Kịch bản (06/10/2026).
// Người dùng không rành kỹ thuật: chọn bằng thẻ / nút lớn (≥ 40 px), trạng thái rõ bằng màu + dấu ✓ + chữ (không chỉ màu), bàn phím mũi tên hoạt động (radiogroup).
import { h } from "../dom";

export interface LuaChonNut { v: string; nhan: string; goiY?: string }

export function phanChon(o: { ten: string; testid: string; ds: LuaChonNut[]; giaTri: string; onDoi: (v: string) => void; nhanNhom?: string }): HTMLElement {
  const nhom = h("div", { class: "kv-seg", role: "radiogroup", "aria-label": o.nhanNhom ?? o.ten, "data-testid": o.testid, dataset: { gt: o.giaTri } });
  const nut: HTMLButtonElement[] = [];
  const ve = (gt: string): void => {
    nhom.dataset.gt = gt;
    for (const b of nut) {
      const dung = b.dataset.v === gt;
      b.setAttribute("aria-checked", String(dung));
      b.tabIndex = dung ? 0 : -1;
      b.classList.toggle("chon", dung);
    }
  };
  for (const l of o.ds) {
    const b = h("button", { type: "button", role: "radio", class: "kv-seg-nut", "data-testid": `${o.testid}-${l.v}`, dataset: { v: l.v }, title: l.goiY, "aria-checked": "false" },
      h("span", { class: "kv-seg-tick", "aria-hidden": "true" }, "✓"), h("span", {}, l.nhan));
    b.addEventListener("click", () => { if (nhom.dataset.gt === l.v) return; ve(l.v); o.onDoi(l.v); });
    nut.push(b);
    nhom.append(b);
  }
  nhom.addEventListener("keydown", (e) => {
    if (!["ArrowRight", "ArrowDown", "ArrowLeft", "ArrowUp"].includes(e.key)) return;
    e.preventDefault();
    const i = Math.max(0, nut.findIndex((b) => b.dataset.v === nhom.dataset.gt));
    const j = (i + (e.key === "ArrowRight" || e.key === "ArrowDown" ? 1 : nut.length - 1)) % nut.length;
    nut[j]!.focus();
    nut[j]!.click();
  });
  ve(o.giaTri);
  return nhom;
}

/** Công tắc bật / tắt bằng hai nút "Bật" / "Tắt" (rõ hơn hộp tick với người không rành kỹ thuật). */
export function congTac(o: { ten: string; testid: string; bat: boolean; onDoi: (b: boolean) => void; chuBat?: string; chuTat?: string }): HTMLElement {
  return phanChon({ ten: o.ten, testid: o.testid, ds: [{ v: "co", nhan: o.chuBat ?? "Bật" }, { v: "khong", nhan: o.chuTat ?? "Tắt" }], giaTri: o.bat ? "co" : "khong", onDoi: (v) => o.onDoi(v === "co") });
}
